import {
  selectAreMultipleDraftComponents,
  selectEditorMode,
} from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

export function useShowDraftComponentsControls() {
  const editorMode = useEditorSelector(selectEditorMode);
  const areMultipleDraftComponents = useEditorSelector(
    selectAreMultipleDraftComponents,
  );

  return editorMode === "edit" && !areMultipleDraftComponents;
}
